import styled from 'styled-components';

export const SportsbookNavigationsBlock = styled.div<{ heightAuto?: boolean }>`
  height: ${props => (props.heightAuto ? 'auto' : 'unset')};
  display: flex;
  flex-direction: column;
  padding-top: 4px;

  .prematchNavigationWrapper {
    background-color: var(--v3-black-0);
    border-radius: 6px;
    overflow: hidden;

    .sportsHeader-titleWrapper {
      border-bottom: 1px solid var(--v3-black-6);
      border-top: none;
      height: 56px;
      font-size: 18px;
    }
    .navigationCollapseWrapper {
      padding: 8px;
    }
  }
`;
